<sc-flex [formGroup]="formGroup">

  <sc-checkbox-field formControlName="checked"
    [labelDictionaryKey]="supplementaryEquipment.dictionaryKey"></sc-checkbox-field>

  <sc-content-spacer></sc-content-spacer>

  <sc-read-only-field [labelDictionaryKey]="supplementaryEquipment.parameter1DictionaryKey"
    [value]="supplementaryEquipment.parameter1Value" style="width: 180px;"></sc-read-only-field>

</sc-flex>
